import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import { documentsActions } from './store/actions/documents.actions';
import { getExpiredDocsCount } from './requests/getExpiredDocsCount';
import { ExpiredButton } from './ExpiredButton';
import { message } from 'antd';

export const ExpiredDocsButton = () => {
  const dispatch = useDispatch();

  const expiredMode = useSelector((state) => state.documentsStore.expiredMode);
  const expiredModeQuery = useSelector(
    (state) => state.documentsStore.expiredModeQuery
  );

  const expiredDocsCountQuery = useQuery(
    ['expiredDocsCount', expiredModeQuery],
    () => getExpiredDocsCount(expiredModeQuery.split('?')[1]),
    {
      initialData: 0,
      onError: () => {
        message.error(
          'Произошла ошибка при загрузке количества просроченных документов'
        );
      },
    }
  );

  return (
    <ExpiredButton
      title="Просроченные документы"
      isActive={expiredMode}
      loading={expiredDocsCountQuery.isFetching}
      count={expiredDocsCountQuery.data}
      onClick={() => {
        dispatch(documentsActions.setExpiredModeValue(!expiredMode));
      }}
    />
  );
};
